import { createI18n } from "vue-i18n";
import en from "./locales/en/en.json";
import tr from "./locales/tr/tr.json";
import ar from "./locales/ar/ar.json";
import fr from "./locales/fr/fr.json";
import de from "./locales/de/de.json";

function loadLocaleMessages() {
  const locales = [{ en: en }, { tr: tr }, { ar: ar }, { fr: fr }, { de: de }];
  const messeges = {};

  locales.forEach((lang) => {
    const key = Object.keys(lang);
    messeges[key] = lang[key];
  });
  return messeges;
}

const savedLanguage = localStorage.getItem("lang") || "en";

export default createI18n({
  locale: savedLanguage,
  fallbackLocale: "en",
  messages: loadLocaleMessages(),
});
